import { Injectable, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BehaviorSubject, map, Observable, tap } from "rxjs";
import { ROUTES } from "../route/routes";

export type Flux = 'spa' | 'tender';

@Injectable({
  providedIn: "root",
})
export class FluxService{

  private fluxSubject = new BehaviorSubject<Flux>('spa');

  public flux$: Observable<Flux> = this.fluxSubject.asObservable();

  constructor(private router: Router) {}

  public initializeFromRoute(route: ActivatedRoute): void {
    route.paramMap.pipe(
      map(params => params.get('flux') as Flux | null),
      tap(fluxParam => {
        if (this.isValidFlux(fluxParam)) {
          this.fluxSubject.next(fluxParam);
        } else {
          console.error('Unknown or invalid flux type:', fluxParam);
          this.router.navigate([ROUTES.HOME.path]); // Fallback route
        }

      }),
    ).subscribe();

  }

  public getCurrentFlux(): Flux {
    return this.fluxSubject.getValue();
  }

  private isValidFlux(fluxParam: string | null): fluxParam is Flux {
    return fluxParam === 'spa' || fluxParam === 'tender';
  }

}